<template lang="pug">
  .mobile-header
    v-app-bar.mobile-header__header(
      app
      color="white"
      fixed
    )
      v-app-bar-nav-icon(@click.stop="drawer = !drawer")
    v-navigation-drawer(
      v-model="drawer"
      fixed
      temporary
    )
      v-list(nav dense)
        v-list-item-group(
          v-model="group"
          active-class="primary--text text--accent-4"
        )
          v-list-item(exact :to="{ name: 'Home' }")
            v-list-item-icon.mr-1
              v-icon(small color="primary darken") mdi-home-outline
            v-list-item-title Home
          v-list-item(exact :to="{ name: 'About' }")
            v-list-item-icon.mr-1
              v-icon(small color="primary darken") mdi-account-details-outline
            v-list-item-title Quem somos
          v-list-item(exact :to="{ name: 'Product' }")
            v-list-item-icon.mr-1
              v-icon(small color="primary darken") mdi-cart-variant
            v-list-item-title Produtos
          v-list-item(exact :to="{ name: 'Contact' }")
            v-list-item-icon.mr-1
              v-icon(small color="primary darken") mdi-card-account-mail-outline
            v-list-item-title Contato
</template>

<script>
  export default {
    name: 'MobileHeader',
    data: () => ({
      drawer: false,
      group: null,
    }),
    watch: {
      group () {
        this.drawer = false
      },
    },
  }
</script>

<style lang="sass" scoped>
@import "@/assets/style/mobileFirst.sass"

.mobile-header
  &__header
    background-image: url('../assets/img/svg/logo-header-min.svg')
    background-position: center
    background-size: 20%
    background-size: 10% !important
    +media-min-sm
      background-size: 5% !important
</style>